import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "expertise-details-skeleton" }
const _hoisted_2 = { class: "categories" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skeleton_loader = _resolveComponent("skeleton-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_skeleton_loader, {
      "max-width": "369px",
      height: "20px",
      "border-radius": _ctx.skeletonBorderRadius
    }, null, 8, ["border-radius"]),
    _createVNode(_component_skeleton_loader, {
      "max-width": "299px",
      height: "20px",
      "border-radius": _ctx.skeletonBorderRadius
    }, null, 8, ["border-radius"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_skeleton_loader, {
        width: "160px",
        "max-width": "160px",
        height: "53px",
        "border-radius": _ctx.skeletonBorderRadius
      }, null, 8, ["border-radius"]),
      _createVNode(_component_skeleton_loader, {
        "max-width": "220px",
        height: "53px",
        "border-radius": _ctx.skeletonBorderRadius
      }, null, 8, ["border-radius"]),
      _createVNode(_component_skeleton_loader, {
        "max-width": "190px",
        height: "53px",
        "border-radius": _ctx.skeletonBorderRadius
      }, null, 8, ["border-radius"]),
      _createVNode(_component_skeleton_loader, {
        "max-width": "240px",
        height: "53px",
        "border-radius": _ctx.skeletonBorderRadius
      }, null, 8, ["border-radius"]),
      _createVNode(_component_skeleton_loader, {
        "max-width": "220px",
        height: "53px",
        "border-radius": _ctx.skeletonBorderRadius
      }, null, 8, ["border-radius"])
    ])
  ]))
}